import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Input,
  Badge,
  Col,
  Row,
  Container,
  CardTitle,
} from "reactstrap";
import CommonTable from "components/CommonComponents/ReactTable/Table";
import Select, { components } from "react-select";
import "react-quill/dist/quill.snow.css";
import {
  DEFAULT_RECORDS_PER_PAGE,
  ASSESSMENT_STATUS_OPTIONS,
} from "components/constant";
import { fixedWidthCustomStyle } from "constants/CommonConstants";
// import { urlEncodedId } from "components/CommonComponents/encodeDecodeFunction";
// import ExistingQuestionModal from "pages/QuestionBank/ExistingQuestionModal";
// import DatePicker from "react-datepicker";
// import AddQuestion from "pages/Courses/AddQuestion";
// import {
//   ASSESSMENT_COURSE_OPTIONS,
//   ASSESSMENT_CRADS,
// } from "components/constant";
import AdminHeader from "components/Headers/AdminHeader";
// import { showAlert } from "components/CommonComponents/CommonFunctions";
// import { REGEX } from "constants/CommonConstants";
import { getAssessmentList } from "action/assessment";
import { useDispatch, useSelector } from "react-redux";
import { assessmentList } from "constants/assessment";
// import { formatDate } from "constants/CommonConstants";
import { getActiveCourseNameList } from "action/batch";


// const initialFields = {
//   assessmentName: {
//     value: "",
//     error: "",
//   },
//   assessmentDuration: {
//     value: "",
//     error: "",
//   },
//   availableFrom: {
//     value: "",
//     error: "",
//   },
//   availableTill: {
//     value: "",
//     error: "",
//   },
//   maxAttempts: {
//     value: "",
//     error: "",
//   },
//   passingPercentage: {
//     value: "",
//     error: "",
//   },
//   status: {
//     value: "INACTIVE",
//     error: "",
//   },
//   totalMark: {
//     value: "",
//     error: "",
//   },
//   maxQuestion: {
//     value: "",
//     error: "",
//   },
// };

// const initialQBQuestion = {
//   question: {
//     en: "",
//     hi: "",
//     error: "",
//   },
//   type: { value: null, error: "" },
//   marks: { value: "", error: "" },
//   options: {
//     value: [
//       { text: "", grade: null },
//       { text: "", grade: null },
//     ],
//     error: "",
//   },
// };

function Assessment() {
  const authData = JSON.parse(localStorage.getItem("p") || "{}");
  // const role = authData?.role;
  // const rolePath =
  //   role === "SUPER_ADMIN"
  //     ? "super-admin"
  //     : role === "ADMIN"
  //       ? "admin"
  //       : role === "CHANNEL_PARTNER"
  //         ? "channel-partner"
  //         : "instructor";

  // const canPerformCrudOperation = role === "SUPER_ADMIN" || role === "ADMIN";

  // const location = useLocation();
  // const assessmentLanguage = new URLSearchParams(location.search).get("lang");
  const dispatch = useDispatch();
  const assessmentListData = useSelector((state) => state.assessment.assessmentList);
  const courseNameListData = useSelector(
    (state) => state.batch.activeCourseNameList,
  );
  const [viewMode, setViewMode] = useState("LIST");
  // const [formData, setFormData] = useState(initialFields);
  const [pageNum, setPageNum] = useState(1);
  const [searchState, setSearchState] = useState({
    searchName: "",
    courseName: null,
    assessmentDate: [null, null],
    status: null,
    filterParams: [],
  });

  // const [isQBPanelOpen, setIsQBPanelOpen] = useState(false);
  // const [qbQuestions, setQbQuestions] = useState([]);
  // const [currentQB, setCurrentQB] = useState(initialQBQuestion);
  // const [negativeGrading, setNegativeGrading] = useState(false);
  // const [qbPanelMode, setQbPanelMode] = useState("ADD"); // ADD | VIEW
  // const [selectedQuestionIndex, setSelectedQuestionIndex] = useState(null);
  // const [showExistingModal, setShowExistingModal] = useState(false);
  // const [showQuestionsTable, setShowQuestionsTable] = useState(false);
  // const [existingQuestionFilters, setExistingQuestionFilters] = useState(null);

  const [listState, setListState] = useState({
    isLoading: true,
    error: "",
    noRecords: false,
    showLoaderOnClick: false,
  });
  const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);

  const formattedAssessmentList = assessmentListData?.data?.assessments?.map(
    (item, index) => {
      return {
        ...item,
        id: item.ID,
        srNo:
          (pageNum - 1) *
          (assessmentListData?.data?.noOfRecordsPerPage ||
            DEFAULT_RECORDS_PER_PAGE) +
          index +
          1,
      };
    },
  );

  const courseOptions =
    courseNameListData?.data?.map((course) => ({
      value: course.ID,
      label: course.courseName,
    })) || [];

  useEffect(() => {
    getActiveCourseNameList(dispatch);
  }, [dispatch]);

  useEffect(() => {
    getAssessmentList(dispatch, pageNum, searchState.filterParams);
    return () => {
      dispatch({ type: assessmentList, payload: {} });
    };
  }, [dispatch, pageNum, searchState.filterParams]);

  useEffect(() => {
    if (assessmentListData?.code === 200) {
      setListState({
        isLoading: false,
        error: "",
        noRecords: assessmentListData?.data?.assessments?.length === 0,
        showLoaderOnClick: false,
      });
    } else if (assessmentListData?.code || assessmentListData?.message) {
      setListState({
        isLoading: false,
        error:
          assessmentListData?.message ||
          "Failed to load assessments list! Please try again.",
        noRecords: false,
        showLoaderOnClick: false,
      });
    }
  }, [assessmentListData]);

  // const loadAssessment = (assessment) => {
  //   setViewMode("EDIT");

  //   setFormData({
  //     assessmentName: {
  //       value: assessment.assessmentName,
  //       error: "",
  //     },
  //     assessmentDuration: {
  //       value: assessment.assessmentDuration,
  //       error: "",
  //     },
  //     availableFrom: {
  //       value: assessment.availableFrom,
  //       error: "",
  //     },
  //     availableTill: {
  //       value: assessment.availableTill,
  //       error: "",
  //     },
  //     maxAttempts: {
  //       value: assessment.maxAttempts,
  //       error: "",
  //     },
  //     passingPercentage: {
  //       value: assessment.passingPercentage,
  //       error: "",
  //     },
  //     status: {
  //       value: assessment.status,
  //       error: "",
  //     },
  //     totalMark: {
  //       value: assessment.totalMark,
  //       error: "",
  //     },
  //     maxQuestion: {
  //       value: assessment.maxQuestion,
  //       error: "",
  //     },
  //   });
  // };

  // const goBackToList = () => {
  //   setViewMode("LIST");
  //   setFormData(initialFields);
  // };

  // const handleSubmit = async () => {
  //   if (!validateForm()) return;
  // };

  // const handleInputChange = (field, value) => {
  //   setFormData((prev) => {
  //     let updatedState = {
  //       ...prev,
  //       [field]: {
  //         value,
  //         error: "",
  //       },
  //     };

  //     return updatedState;
  //   });
  // };

  // const openViewQuestion = (question, index) => {
  //   setCurrentQB({
  //     question: {
  //       en: question.question?.en || "",
  //       hi: question.question?.hi || "",
  //       error: "",
  //     },
  //     type: { value: question.type, error: "" },
  //     marks: { value: question.marks ?? "", error: "" },
  //     options: {
  //       value: question.options.map((o) => ({ ...o })),
  //       error: "",
  //     },
  //   });

  //   // setNegativeGrading(question.negativeGrading);
  //   setSelectedQuestionIndex(index);
  //   setQbPanelMode("VIEW");
  //   setIsQBPanelOpen(true);
  // };

  // const validateForm = () => {
  //   let newSkill = { ...formData };

  //   Object.keys(newSkill).forEach((key) => {
  //     newSkill[key] = {
  //       ...newSkill[key],
  //       error: getValidationError(key, newSkill[key].value),
  //     };
  //   });

  //   setFormData(newSkill);
  //   return Object.values(newSkill).every((item) => item.error === "");
  // };

  // //on blur to get if any validation error exits
  // const handleOnBlur = (name, value) => {
  //   const trimmedValue = typeof value === "string" ? value.trim() : value;
  //   const error = getValidationError(name, trimmedValue);
  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: {
  //       ...prev[name],
  //       value: trimmedValue,
  //       error,
  //     },
  //   }));
  // };

  const buildFilterParams = () => {
    const filterParams = [];

    if (searchState.courseName?.value) {
      filterParams.push({
        field: "CourseID",
        condition: "eq",
        filterValues: [String(searchState.courseName.value)],
      });
    }

    if (searchState.searchName?.trim()) {
      filterParams.push({
        field: "AssessmentName",
        condition: "like",
        filterValues: [searchState.searchName.trim()],
      });
    }

    if (searchState.status?.value) {
      filterParams.push({
        field: "Status",
        condition: "eq",
        filterValues: [searchState.status.value],
      });
    }

    // if (searchState.assessmentDate?.[0]) {
    //   if (searchState.assessmentDate?.[1]) {
    //     filterParams.push({
    //       field: "CreatedAt",
    //       condition: "btw",
    //       filterValues: [
    //         formatDate(searchState.assessmentDate[0]),
    //         formatDate(searchState.assessmentDate[1]),
    //       ],
    //     });
    //   } else {
    //     filterParams.push({
    //       field: "CreatedAt",
    //       condition: "eq",
    //       filterValues: [formatDate(searchState.assessmentDate[0])],
    //     });
    //   }
    // }

    return filterParams;
  };

  const handleSearch = () => {
    const newFilterParams = buildFilterParams();

    if (
      JSON.stringify(searchState.filterParams) !==
      JSON.stringify(newFilterParams)
    ) {
      setListState((prev) => ({
        ...prev,
        isLoading: true,
        showLoaderOnClick: true,
      }));

      setSearchState((prev) => ({
        ...prev,
        filterParams: newFilterParams,
      }));

      if (pageNum !== 1) {
        setPageNum(1);
      }
    }
  };


  // const getValidationError = (name, value) => {
  //   switch (name) {
  //     case "assessmentName":
  //       if (!value?.trim()) return "Assessment name is required";
  //       if (value.trim().length < 5)
  //         return "Assessment name must be at least 5 characters";
  //       if (value.trim().length > 100)
  //         return "Assessment name cannot exceed 100 characters";
  //       return "";

  //     case "assessmentDuration":
  //       if (!value) return "Assessment duration is required";
  //       if (Number(value) < 1) return "Duration must be at least 1 minute";
  //       return "";

  //     case "availableFrom":
  //       if (!value) return "Available from date & time is required";
  //       return "";

  //     case "availableTill":
  //       if (!value) return "Available till date & time is required";
  //       if (
  //         formData.availableFrom.value &&
  //         new Date(value) <= new Date(formData.availableFrom.value)
  //       ) {
  //         return "Available till must be after available from";
  //       }
  //       return "";

  //     case "maxAttempts":
  //       if (!value) return "Maximum attempts is required";
  //       if (Number(value) < 1) return "Maximum attempts must be at least 1";
  //       return "";

  //     case "passingPercentage":
  //       if (!value && value !== 0) return "Passing percentage is required";
  //       if (Number(value) < 1 || Number(value) > 100)
  //         return "Passing percentage must be between 1 and 100";
  //       return "";

  //     //for total marks from backend validation is not applied yet
  //     case "totalMark":
  //       if (value <= 0) return "Total mark must be greater than zero";
  //       return "";

  //     //for max ques from backend validation is not applied yet
  //     case "maxQuestion":
  //       if (!value) return "Maximum no of question required";
  //       if (value <= 0) return "Must be greater than 0";
  //       return "";

  //     default:
  //       return "";
  //   }
  // };

  //with value we have to limit to length
  // const handleNumberInput = (field, maxDigits) => (e) => {
  //   const value = e.target.value;

  //   if (REGEX.ONLY_DIGITS_REGEX.test(value) && value.length <= maxDigits) {
  //     handleInputChange(field, value);
  //   }
  // };

  // const getFreshQBQuestion = () => ({
  //   question: { value: "", error: "" },
  //   type: { value: null, error: "" },
  //   level: { value: null, error: "" },
  //   marks: { value: "", error: "" },
  //   options: {
  //     value: [
  //       { text: "", grade: null },
  //       { text: "", grade: null },
  //     ],
  //     error: "",
  //   },
  // });

  // const closeModal = () => {
  //   setCurrentQB(getFreshQBQuestion());
  //   setIsQBPanelOpen(false);
  // };

  // const resetQBPanel = () => {
  //   setCurrentQB(getFreshQBQuestion());
  //   setIsQBPanelOpen(true);
  // };

  const clearSearch = () => {
    setListState((prev) => ({
      ...prev,
      isLoading: true,
      showLoaderOnClick: false,
    }));

    setSearchState({
      searchName: "",
      courseName: null,
      assessmentDate: [null, null],
      status: null,
      filterParams: [],
    });

    if (pageNum !== 1) {
      setPageNum(1);
    }
  };

  const handleKeyDown = (e, disable = true) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch();
    }
  };

  const getBadgeColor = (status) => {
    switch (status) {
      case "PUBLISHED":
        return "success";
      case "DRAFT":
        return "warning";
      case "ACTIVE":
        return "success";
      case "CLOSED":
        return "warning";
      case "UPCOMING":
        return "info";
      default:
        return "gray";
    }
  };

  const Option = (props) => (
    <components.Option {...props}>
      <Badge color={getBadgeColor(props.data.value)} pill>
        {props.data.label}
      </Badge>
    </components.Option>
  );

  const SingleValue = (props) => (
    <components.SingleValue {...props}>
      <Badge color={getBadgeColor(props.data.value)} pill>
        {props.data.label}
      </Badge>
    </components.SingleValue>
  );

  const columns = [
    {
      Header: "Sr. No.",
      accessor: "srNo",
      minWidth: 80,
      maxWidth: 80,
      centerAlign: true,
    },
    {
      Header: "Course Name",
      accessor: "courseName",
      minWidth: 200,
      maxWidth: 200,
      Cell: ({ value }) => <div className="text-wrap-cell">{value}</div>,
    },
    {
      Header: "Assessment Name",
      accessor: "assessmentName",
      minWidth: 200,
      maxWidth: 200,
      Cell: ({ value }) => <div className="text-wrap-cell">{value}</div>,
    },
    // {
    //   Header: "Duration",
    //   accessor: "assessmentDuration",
    //   Cell: ({ value }) => (value ? `${value} min` : "-"),
    // },
    // {
    //   Header: "Max Attempts",
    //   accessor: "maxAttempts",
    //   centerAlign: true,
    // },
    // {
    //   Header: "Passing %",
    //   accessor: "passingPercentage",
    //   Cell: ({ value }) => (value !== undefined ? `${value}%` : "-"),
    // },
    // {
    //   Header: "Available From",
    //   accessor: "availableFrom",
    //   Cell: ({ value }) =>
    //     value ? ISOToHumanReadableWithTimeDate(value) : "-",
    // },
    // {
    //   Header: "Available Till",
    //   accessor: "availableTill",
    //   Cell: ({ value }) =>
    //     value ? ISOToHumanReadableWithTimeDate(value) : "-",
    // },
    {
      Header: "Assigned By",
      accessor: "assignedBy",
      minWidth: 100,
      maxWidth: 100,
    },
    {
      Header: "Status",
      accessor: "status",
      centerAlign: true,
      minWidth: 80,
      maxWidth: 80,
      Cell: ({ value }) => (
        <Badge color={getBadgeColor(value)} pill>
          {value}
        </Badge>
      ),
    },
    {
      Header: "Created On",
      accessor: "createdAt",
      minWidth: 150,
      maxWidth: 150,
    },
    // {
    //   Header: "Actions",
    //   accessor: "actions",
    //   Cell: ({ row }) => {
    //     const assessment = row.original;
    //     const encodedId = urlEncodedId(assessment.id);
    //     const status = assessment.status;

    //     return (
    //       <div className="d-flex align-items-center">
    //         {/* View */}

    //         <Button
    //           color="link"
    //           className="p-0"
    //           id={`view${encodedId}`}
    //           onClick={() =>
    //             navigate(`/${rolePath}/assessment/${encodedId}/details`)
    //           }
    //         >
    //           <i className="fas fa-eye mr-1 table-action-primary" />
    //         </Button>
    //         <UncontrolledTooltip delay={0} target={`view${encodedId}`}>
    //           View
    //         </UncontrolledTooltip>

    //         {/* Edit */}
    //         {canPerformCrudOperation && (
    //           <>
    //             <Button
    //               color="link"
    //               className="p-0 ml-2"
    //               id={`edit${encodedId}`}
    //             // onClick={() => loadAssessment(assessment)}
    //             >
    //               <i className="fa fa-edit mr-1 table-action-info" />
    //             </Button>
    //             <UncontrolledTooltip delay={0} target={`edit${encodedId}`}>
    //               Edit
    //             </UncontrolledTooltip>
    //           </>
    //         )}

    //         {canPerformCrudOperation && (
    //           <span className="mx-1 text-muted">|</span>
    //         )}
    //         {canPerformCrudOperation && (
    //           <>
    //             <Button
    //               color="link"
    //               size="lg"
    //               className="d-flex align-items-center p-0 ml-1"
    //               id={`delete${encodedId}`}
    //               onClick={(e) => {
    //                 e.stopPropagation();
    //                 // handleStatusToggle(assessment);
    //               }}
    //             >
    //               <i
    //                 className={`fas status-toggle-icon ${status === "ACTIVE"
    //                   ? "fa-toggle-on text-success"
    //                   : "fa-toggle-off text-danger"
    //                   }`}
    //               />
    //             </Button>
    //             <UncontrolledTooltip delay={0} target={`delete${encodedId}`}>
    //               {status === "ACTIVE" ? "Deactivate" : "Activate"}
    //             </UncontrolledTooltip>
    //           </>
    //         )}
    //       </div>
    //     );
    //   },
    // },
  ];

  // const handleStatusToggle = (assessment) => {
  //   const { id, status } = assessment;

  //   const isActive = status === "ACTIVE";
  //   const newStatus = isActive ? "CLOSED" : "ACTIVE";

  //   showAlert({
  //     title: `Are you sure you want to ${isActive ? "deactivate" : "activate"
  //       } this assessment?`,
  //     type: "warning",
  //     confirmStyle: "deep-blue",
  //     cancelStyle: "secondary",
  //     confirmText: "Yes",
  //     cancelText: "No",

  //     onConfirm: () => {
  //       setIsUpdatingStatus(true);

  //       // Simulate API call
  //       setTimeout(() => {
  //         // setAssessmentList((prev) =>
  //         //   prev.map((item) =>
  //         //     item.id === id
  //         //       ? {
  //         //         ...item,
  //         //         status: newStatus,
  //         //       }
  //         //       : item,
  //         //   ),
  //         // );

  //         setIsUpdatingStatus(false);
  //       }, 1000); // 1 second dummy delay
  //     },
  //   });
  // };

  // const questionColumns = [
  //   {
  //     Header: "Sr. No.",
  //     accessor: "srNo",
  //   },
  //   {
  //     Header: "Question",
  //     accessor: "question",
  //     Cell: ({ value }) => (
  //       <div
  //         dangerouslySetInnerHTML={{
  //           __html: value?.en || value?.hi || "",
  //         }}
  //         className="max-width-25"
  //       />
  //     ),
  //   },
  //   {
  //     Header: "Options",
  //     accessor: "options",
  //     Cell: ({ row }) => {
  //       const { type, options } = row.original;

  //       // Description questions have no options
  //       if (type === "DESC") {
  //         return <span className="text-muted">—</span>;
  //       }

  //       return (
  //         <div className="max-width-25">
  //           {options?.map((opt, idx) => (
  //             <div key={idx} className="d-flex align-items-baseline mb-1">
  //               <strong className="mr-1">{idx + 1}.</strong>
  //               <div dangerouslySetInnerHTML={{ __html: opt.text }} />
  //             </div>
  //           ))}
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     Header: "Type",
  //     accessor: "type",
  //     Cell: ({ value }) =>
  //       value === "MCQ"
  //         ? "Single Choice"
  //         : value === "MULTI"
  //           ? "Multiple Choice"
  //           : value === "TF"
  //             ? "True / False"
  //             : "Description",
  //   },
  //   {
  //     Header: "Marks",
  //     accessor: "marks",
  //     Cell: ({ value }) => (
  //       <span className="font-weight-bold">
  //         {value !== "" && value !== undefined ? value : "-"}
  //       </span>
  //     ),
  //   },
  //   {
  //     Header: "Actions",
  //     Cell: ({ row }) => {
  //       const id = row.index;

  //       return (
  //         <div className="d-flex align-items-center">
  //           {/* View */}
  //           <Button
  //             color="link"
  //             className="p-0 mr-2"
  //             id={`viewQuestion${id}`}
  //             onClick={() => openViewQuestion(row.original, row.index)}
  //           >
  //             <i className="fa fa-edit mr-1" />
  //           </Button>
  //           <UncontrolledTooltip target={`viewQuestion${id}`}>
  //             Edit
  //           </UncontrolledTooltip>

  //           {/* Remove */}
  //           <Button
  //             color="link"
  //             className="btn-link d-flex align-items-center p-0 table-action-delete"
  //             id={`deleteQuestion${id}`}
  //             onClick={() =>
  //               setQbQuestions((prev) => prev.filter((_, i) => i !== row.index))
  //             }
  //           >
  //             <i className="fas fa-trash mx-1 table-action-delete" />
  //           </Button>
  //           <UncontrolledTooltip target={`deleteQuestion${id}`}>
  //             Delete
  //           </UncontrolledTooltip>
  //         </div>
  //       );
  //     },
  //   },
  // ];

  return (
    <>
      <AdminHeader />
      {isUpdatingStatus && (
        <div className="logout-overlay">
          <div className="logout-card">
            <i className="fa fa-spinner fa-spin fa-2x text-deep-blue mb-4" />
            <div className="font-weight-bold text-dark">
              Updating status... Please wait.
            </div>
          </div>
        </div>
      )}
      <Container fluid className="mt--6">
        {viewMode === "LIST" && (
          <>
            {/* <Card>
              <CardHeader>
                <Row>
                  {ASSESSMENT_CRADS.map((card, index) => (
                    <Col
                      xl="3"
                      lg="3"
                      md="6"
                      sm="6"
                      xs="12"
                      className="mb-2"
                      key={index}
                    >
                      <Card className="shadow-sm stats-card">
                        <CardBody className="py-2">
                          <div className="d-flex justify-content-between align-items-center">
                            <div>
                              <h3 className="mb-1">{card.title}</h3>
                              <div className="text-muted">{card.subtitle}</div>
                            </div>

                            <i
                              className={`${card.icon} stats-card-icon ${card.iconClass}`}
                            />
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </CardHeader>
            </Card> */}
            <Row>
              <Col md="12">
                <Card>
                  <CardHeader className="d-flex justify-content-between align-items-center">
                    <CardTitle tag="h3" className="mb-0 text-default">Assessments</CardTitle>
                  </CardHeader>

                  <CardBody>
                    <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap flex-column flex-md-row">
                      <div className="d-flex flex-wrap align-items-center filter-group">

                        <Select
                          className="mr-2 mb-2 filter-select"
                          options={courseOptions}
                          placeholder="Select course name"
                          classNamePrefix="react-select"
                          styles={fixedWidthCustomStyle()}
                          value={searchState.courseName}
                          onChange={(selected) =>
                            setSearchState((prev) => ({
                              ...prev,
                              courseName: selected,
                            }))
                          }
                        />

                        <Input
                          type="text"
                          placeholder="Search by assessment name"
                          className="mr-2 mb-2 filter-input-large"
                          value={searchState.searchName}
                          onChange={(e) =>
                            setSearchState((prev) => ({
                              ...prev,
                              searchName: e.target.value,
                            }))
                          }
                          onKeyDown={handleKeyDown}
                        />

                        {/* <DatePicker
                          selected={searchState.assessmentDate[0]}
                          onChange={(dates) =>
                            setSearchState((prev) => ({
                              ...prev,
                              assessmentDate: dates,
                            }))
                          }
                          startDate={searchState.assessmentDate[0]}
                          endDate={searchState.assessmentDate[1]}
                          selectsRange
                          onKeyDown={(e) => handleKeyDown(e, true)}
                          isClearable={!!searchState.assessmentDate[0]}
                          placeholderText="Select created on date or range"
                          className="form-control mr-2 mb-2 filter-input-large"
                          dateFormat="dd-MMM-yyyy"
                          showMonthDropdown
                          showYearDropdown
                          scrollableYearDropdown
                          yearDropdownItemNumber={100}
                          calendarClassName="custom-calendar"
                          popperClassName="datepicker-popper"
                          onPaste={(e) => e.preventDefault()}
                        /> */}

                        <Select
                          className="mr-2 mb-2 filter-select"
                          options={ASSESSMENT_STATUS_OPTIONS}
                          placeholder="Select status"
                          components={{ Option, SingleValue }}
                          classNamePrefix="react-select"
                          styles={fixedWidthCustomStyle()}
                          value={searchState.status}
                          onChange={(selected) =>
                            setSearchState((prev) => ({
                              ...prev,
                              status: selected,
                            }))
                          }
                          onKeyDown={handleKeyDown}
                        />

                        <Button
                          color="default"
                          className={`d-flex align-items-center mb-2 filter-btn btn-deep-blue ${listState.showLoaderOnClick ? "search-btn" : ""
                            }`}
                          onClick={handleSearch}
                          disabled={listState.showLoaderOnClick}
                        >
                          {listState.showLoaderOnClick ? (
                            <i className="fa fa-spinner fa-spin loader" />
                          ) : (
                            <>
                              <i className="fa fa-search mr-1" />
                              Search
                            </>
                          )}

                        </Button>

                        {searchState.filterParams.length > 0 && (
                          <Button
                            color="default"
                            className="mb-2 filter-btn btn-simple btn-deep-blue"
                            onClick={clearSearch}
                          >
                            <i className="fa fa-times mr-1" />
                            Clear
                          </Button>
                        )}
                      </div>
                    </div>

                    <div className="mt-2 mb-3 mx-1">
                      {assessmentListData?.data?.totalRecords > 0 ? (
                        <>
                          {searchState.filterParams.length > 0 ? (
                            <span className="total-records">
                              Showing {assessmentListData?.data?.totalFilteredRecords} of{" "}
                              {assessmentListData?.data?.totalRecords} Records
                            </span>
                          ) : (
                            <span className="total-records">
                              Total Records : {assessmentListData?.data?.totalRecords}
                            </span>
                          )}
                        </>
                      ) : null}
                    </div>

                    {listState.isLoading ? (
                      <div className="loaderContainer">
                        <i className="fa fa-spinner fa-spin fa-2xl loader" />
                      </div>
                    ) : listState.error ? (
                      <>
                        <div className="loaderContainer error-style">
                          <div className="error-icon">
                            <i class="fa-solid fa-circle-exclamation"></i>
                          </div>
                          <span>{listState.error}</span>
                        </div>
                      </>
                    ) : listState.noRecords ? (
                      <div className="loaderContainer empty-style">
                        <div className="empty-icon">
                          <i class="fa-solid fa-circle-info"></i>
                        </div>
                        <span>No assessments found.</span>
                      </div>
                    ) : (
                      <div className="table-responsive">
                        <CommonTable
                          data={formattedAssessmentList || []}
                          columns={columns}
                          pageNum={pageNum}
                          setPageNum={setPageNum}
                          defaultPageSize={DEFAULT_RECORDS_PER_PAGE}
                          showPaginationBottom
                          totalPages={Math.ceil(
                            assessmentListData?.data?.totalFilteredRecords / assessmentListData?.data?.noOfRecordsPerPage || DEFAULT_RECORDS_PER_PAGE,
                          )}
                        />
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </>
        )}

        {/* {viewMode !== "LIST" && (
          <>
            <Row className="justify-content-center">
              <Col>
                <Card className="mb-3">
                  <CardHeader className="d-flex align-items-center">
                    <h4 className="mb-0 text-default section-title">
                      Edit Assessment
                    </h4>
                  </CardHeader>

                  <Form onSubmit={(e) => e.preventDefault()}>
                    <CardBody>
                      <Row>
                        <Col md="4" className="mb-3">
                          <FormGroup>
                            <Label className="form-control-label">
                              Assessment Name{" "}
                              <span className="text-danger">*</span>
                            </Label>
                            <Input
                              type="text"
                              placeholder="Enter assessment name"
                              value={formData.assessmentName.value}
                              onChange={(e) =>
                                handleInputChange(
                                  "assessmentName",
                                  e.target.value,
                                )
                              }
                              onBlur={(e) =>
                                handleOnBlur("assessmentName", e.target.value)
                              }
                              className={
                                formData.assessmentName.error
                                  ? "is-invalid"
                                  : ""
                              }
                              minLength={5}
                              maxLength={100}
                            />

                            {formData.assessmentName.error && (
                              <small className="invalid-feedback d-block">
                                {formData.assessmentName.error}
                              </small>
                            )}
                          </FormGroup>
                        </Col>

                        <Col md="4" className="mb-3">
                          <FormGroup>
                            <Label className="form-control-label d-block">
                              Assessment Duration (minutes)
                              <span className="text-danger">*</span>
                            </Label>

                            <Input
                              type="number"
                              min={1}
                              placeholder="Enter duration in minutes"
                              value={formData.assessmentDuration.value}
                              onChange={handleNumberInput(
                                "assessmentDuration",
                                4,
                              )}
                              onBlur={(e) =>
                                handleOnBlur(
                                  "assessmentDuration",
                                  e.target.value,
                                )
                              }
                              className={
                                formData.assessmentDuration.error
                                  ? "is-invalid"
                                  : ""
                              }
                            />

                            {formData.assessmentDuration.error && (
                              <small className="invalid-feedback d-block">
                                {formData.assessmentDuration.error}
                              </small>
                            )}
                          </FormGroup>
                        </Col>

                        <Col md="4" className="mb-3">
                          <FormGroup>
                            <Label className="form-control-label d-block">
                              Passing Percentage{" "}
                              <span className="text-danger">*</span>
                            </Label>
                            <Input
                              type="number"
                              min={1}
                              max={100}
                              placeholder="Enter passing percentage"
                              value={formData.passingPercentage.value}
                              onChange={handleNumberInput(
                                "passingPercentage",
                                3,
                              )} //means min 1 to max 100 so 3 digit
                              onBlur={(e) =>
                                handleOnBlur(
                                  "passingPercentage",
                                  e.target.value,
                                )
                              }
                              className={
                                formData.passingPercentage.error
                                  ? "is-invalid"
                                  : ""
                              }
                            />
                            {formData.passingPercentage.error && (
                              <small className="invalid-feedback d-block">
                                {formData.passingPercentage.error}
                              </small>
                            )}
                          </FormGroup>
                        </Col>

                        <Col md="4" className="mb-3">
                          <FormGroup>
                            <Label className="form-control-label d-block">
                              Available From{" "}
                              <span className="text-danger">*</span>
                            </Label>
                            <DatePicker
                              selected={
                                formData.availableFrom.value
                                  ? new Date(formData.availableFrom.value)
                                  : null
                              }
                              onChange={(date) =>
                                handleInputChange("availableFrom", date)
                              }
                              onBlur={() =>
                                handleOnBlur(
                                  "availableFrom",
                                  formData.availableFrom.value,
                                )
                              }
                              dateFormat="dd-MMM-yyyy, hh:mm aa"
                              placeholderText="Select available from date"
                              showTimeSelect
                              timeFormat="hh:mm aa"
                              timeIntervals={1}
                              minDate={new Date()}
                              showIcon
                              showMonthDropdown
                              showYearDropdown
                              scrollableYearDropdown
                              yearDropdownItemNumber={100}
                              icon={
                                <i className="fa-solid fa-calendar-day fa-md mt-1 mr-4 text-muted" />
                              }
                              toggleCalendarOnIconClick
                              className={`form-control ${formData.availableFrom.error ? "is-invalid" : ""
                                }`}
                              wrapperClassName="w-100"
                              calendarClassName="custom-calendar"
                              popperPlacement="bottom-start"
                              onKeyDown={(e) => e.preventDefault()}
                              onPaste={(e) => e.preventDefault()}
                            />
                            {formData.availableFrom.error && (
                              <small className="invalid-feedback d-block">
                                {formData.availableFrom.error}
                              </small>
                            )}
                          </FormGroup>
                        </Col>

                        <Col md="4" className="mb-3">
                          <FormGroup>
                            <Label className="form-control-label d-block">
                              Available Till{" "}
                              <span className="text-danger">*</span>
                            </Label>
                            <DatePicker
                              selected={
                                formData.availableTill.value
                                  ? new Date(formData.availableTill.value)
                                  : null
                              }
                              onChange={(date) =>
                                handleInputChange("availableTill", date)
                              }
                              onBlur={() =>
                                handleOnBlur(
                                  "availableTill",
                                  formData.availableTill.value,
                                )
                              }
                              dateFormat="dd-MMM-yyyy, hh:mm aa"
                              placeholderText="Select available till date"
                              showTimeSelect
                              timeFormat="hh:mm aa"
                              timeIntervals={1}
                              minDate={formData.availableFrom.value}
                              showIcon
                              showMonthDropdown
                              showYearDropdown
                              scrollableYearDropdown
                              yearDropdownItemNumber={100}
                              icon={
                                <i className="fa-solid fa-calendar-day fa-md mt-1 mr-4 text-muted" />
                              }
                              toggleCalendarOnIconClick
                              className={`form-control ${formData.availableTill.error ? "is-invalid" : ""
                                }`}
                              wrapperClassName="w-100"
                              calendarClassName="custom-calendar"
                              popperPlacement="bottom-start"
                              onKeyDown={(e) => e.preventDefault()}
                              onPaste={(e) => e.preventDefault()}
                            />
                            {formData.availableTill.error && (
                              <small className="invalid-feedback d-block">
                                {formData.availableTill.error}
                              </small>
                            )}
                          </FormGroup>
                        </Col>

                        <Col md="4" className="mb-3">
                          <FormGroup>
                            <Label className="form-control-label d-block">
                              Maximum Attempts{" "}
                              <span className="text-danger">*</span>
                            </Label>
                            <Input
                              type="text"
                              min={1}
                              placeholder="Enter max attempts"
                              value={formData.maxAttempts.value}
                              onChange={handleNumberInput("maxAttempts", 2)} //for now given 2 means 2 digit length can change
                              onBlur={(e) =>
                                handleOnBlur("maxAttempts", e.target.value)
                              }
                              className={
                                formData.maxAttempts.error ? "is-invalid" : ""
                              }
                            />
                            {formData.maxAttempts.error && (
                              <small className="invalid-feedback d-block">
                                {formData.maxAttempts.error}
                              </small>
                            )}
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="4" className="mb-3">
                          <FormGroup>
                            <Label className="form-control-label">
                              Total Mark <span className="text-danger">*</span>
                            </Label>
                            <Input
                              type="number"
                              placeholder="Enter total mark"
                              value={formData.totalMark.value}
                              onChange={handleNumberInput("totalMark", 3)} // 3 digit means 100 or 200 can change
                              onBlur={(e) =>
                                handleOnBlur("totalMark", e.target.value)
                              }
                              className={
                                formData.totalMark.error ? "is-invalid" : ""
                              }
                            />

                            {formData.totalMark.error && (
                              <small className="invalid-feedback d-block">
                                {formData.totalMark.error}
                              </small>
                            )}
                          </FormGroup>
                        </Col>

                        <Col md="4" className="mb-3">
                          <FormGroup>
                            <Label className="form-control-label">
                              No.of Max Question{" "}
                              <span className="text-danger">*</span>
                            </Label>
                            <Input
                              type="text"
                              placeholder="Enter max Question"
                              value={formData.maxQuestion.value}
                              onChange={handleNumberInput("maxQuestion", 3)} // 3 digit as per condi means 100 ques
                              onBlur={(e) =>
                                handleOnBlur("maxQuestion", e.target.value)
                              }
                              className={
                                formData.maxQuestion.error ? "is-invalid" : ""
                              }
                            />

                            {formData.maxQuestion.error && (
                              <small className="invalid-feedback d-block">
                                {formData.maxQuestion.error}
                              </small>
                            )}
                          </FormGroup>
                        </Col>
                      </Row> */}
        {/* <div className="d-flex justify-content-between align-items-center pb-3"> */}
        {/* <FormGroup className="mb-0">
                                      <Label className="form-control-label">
                                        Negative Grading
                                        <InfoPopover
                                          targetId="negativeGradingInfo"
                                          title="Negative Grading"
                                          content="When enabled, incorrect answers will reduce the total score based on the selected grade percentage."
                                        />
                                      </Label>
                  
                                      <div className="d-flex mt-2">
                                        <FormGroup check className="mr-5">
                                          <Label check className="cursor">
                                            <Input
                                              type="radio"
                                              name="negativeGrading"
                                              checked={negativeGrading === true}
                                              onChange={() => setNegativeGrading(true)}
                                            />
                                            Yes
                                          </Label>
                                        </FormGroup>
                  
                                        <FormGroup check>
                                          <Label check className="cursor">
                                            <Input
                                              type="radio"
                                              name="negativeGrading"
                                              checked={negativeGrading === false}
                                              onChange={() => setNegativeGrading(false)}
                                            />
                                            No
                                          </Label>
                                        </FormGroup>
                                      </div>
                                    </FormGroup> */}
        {/* <div className="d-flex align-items-center justify-content-end pb-3"> */}
        {/* <Button
                                        color="default"
                                        className="btn-deep-blue"
                                        onClick={resetQBPanel}
                                      >
                                        <i className="fa fa-plus mr-1" />
                                        Question
                                      </Button> */}

        {/* <Button
                          className="btn-deep-blue mr-5"
                          onClick={() => setShowExistingModal(true)}
                        >
                          <i className="fa fa-plus mr-1 cursor" />
                          Existing Questions
                        </Button>
                      </div> */}
        {/* </div> */}

        {/* <CommonTable
                        columns={questionColumns}
                        data={qbQuestions.map((q, index) => ({
                          ...q,
                          srNo: index + 1,
                        }))}
                        showPaginationBottom={false}
                      />

                      <AddQuestion
                        assessmentLanguage={assessmentLanguage}
                        // negativeGrading={negativeGrading}
                        isOpen={isQBPanelOpen}
                        onClose={closeModal}
                        onSave={(question, index, mode) => {
                          if (mode === "VIEW") {
                            setQbQuestions((prev) =>
                              prev.map((q, i) => (i === index ? question : q)),
                            );
                          } else {
                            setQbQuestions((prev) => [...prev, question]);
                          }
                        }}
                        mode={qbPanelMode}
                        selectedIndex={selectedQuestionIndex}
                        initialData={currentQB}
                      />
                    </CardBody>

                    <CardFooter className="text-right">
                      <Button color="secondary" onClick={goBackToList}>
                        Cancel
                      </Button>
                      <Button color="deep-blue" onClick={handleSubmit}>
                        Save
                      </Button>
                    </CardFooter>
                  </Form>
                </Card>
              </Col>
            </Row>
          </>
        )} */}
        {/* <ExistingQuestionModal
          isOpen={showExistingModal}
          toggleModal={() => setShowExistingModal(false)}
          onSave={(data) => {
            setExistingQuestionFilters(data);
            setShowQuestionsTable(true);
            setShowExistingModal(false);
          }}
        /> */}
      </Container>
    </>
  );
}

export default Assessment;
